import { fetchData } from "../../utils/Http"
import { serverUrl } from "../../utils/Settings"

type Request = Hotelstouch.WebApp.WebShop.Api.SubmitOrder.Request
type Response = Hotelstouch.WebApp.WebShop.Api.SubmitOrder.Response

export async function submitOrderApi(params: Request):Promise<Response>{
    return await fetchData<Response>(`${serverUrl}/api/publicWebShop/submit`, params)
}